if (!customElements.get('fotosound-offers')) {
  class FotosoundOffers extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-fs-offer-rail]');
      this.querySelector('[data-fs-prev]')?.addEventListener('click', () => this.move(-1));
      this.querySelector('[data-fs-next]')?.addEventListener('click', () => this.move(1));
    }

    move(direction) {
      if (!this.rail) return;
      const card = this.rail.querySelector('.fs-offer-card');
      const gap = Number.parseFloat(getComputedStyle(this.rail).gap) || 0;
      this.rail.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || this.rail.clientWidth) + gap), behavior: 'smooth' });
    }
  }

  customElements.define('fotosound-offers', FotosoundOffers);
}

